import {FinanceMassStatusChangeList} from './finance-mass-status-change-list';

export class FinanceMassStatusChange {
  statusCode: string;
  changeList: FinanceMassStatusChangeList[] = [];
}
